import { RootState } from "typedefs";
import { useEffect } from "react";
import { useActions, useSelector } from "app/utils/hooks";
import { fetchTimeZones } from "app/actions/scheduling/timeZone";

export const useTimeZonesModel = () => {
  const actions = useActions({
    fetchTimeZones,
  });

  useEffect(() => {
    actions.fetchTimeZones();
  }, []);

  const timeZones = useSelector(
    (state: RootState) => state.schedulingTimeZones,
  );

  return timeZones;
};
